import MetricGraph from "./Graph";

const MetricTab = ({ metrics }) => {
  return <MetricGraph metrics={metrics} />;
};

export default MetricTab;
